var Popup = {};


//--------------
// Variable
//--------------

Popup.popup = '.js-popup';
Popup.opener = '.js-open-popup';
Popup.closer = '.js-close-popup';


/**
 * Open Popup
 * @return {void}
 */
Popup.open = function(el) {
	var dataPopup = $(el).attr('data-popup');

	$(Popup.popup +'[data-popup="'+ dataPopup +'"]').fadeIn();
}

/**
 * Close Popup
 * @return {void}
 */
Popup.close = function(el) {
	$(el).closest('.js-popup').fadeOut();
}


//--------------
// Execution
//--------------

Popup.init = function(){
	// Open Popup
	$('body').on('click', Popup.opener, function(){
		Popup.open(this);
	});

	// Close Popup
	$('body').on('click', Popup.closer, function(){
		Popup.close(this);
	});
}

Popup.init();

module.exports = Popup;
